module.exports = __webpack_public_path__ + "static/media/7.4bae9571.jpg";